import { MenuItem, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import styled from 'styled-components';
import { colors } from '@custom-components';

export const StyledMenuItem = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '-10px',
    '&:focus': {
      backgroundColor: theme.palette.grey[100]
    }
  }
}))(MenuItem);

export const IconWrapper = styled.div`
  margin-right: 5px;
  justify-content: center;
  display: flex;
`;

export const DropDownLabelWrapper = styled.div`
  width: 100%;
  color: ${(props) => props.color};
`;

export const DropdownArrowIconWrapper = styled.div`
  border-left: ${(props) => `1px solid ${props.color}`};
  margin: -5px;
  margin-right: -20px;
  margin-left: 10px;
`;

export const StyledTypography = styled(Typography)`
  color: ${(props) => (props.isDelete ? colors.colorRed : 'inherit')};
`;
